'use client'

import React, { useContext, useMemo } from 'react'

// import vnd from '~/images/vnd.png'
// import usdt from '~/images/usdt.png'
// import wusd from '~/images/wusd.png'

import './style.scss'
import { ActionContext } from 'controller/context/ActionProvider'
import images from 'assets/images'

function Dropdown() {
  const { state, setState } = useContext(ActionContext)
  const { setMoneyChoose } = setState
  const { moneyChoose } = state

  const [isOpen, setIsOpen] = React.useState(false)

  const resultDropdown = useMemo(() => {
    if (moneyChoose) {
      return (
        <div className='dropdown-result'>
          <img src={moneyChoose.icon} alt='' className='img-money' />
          <div className='dropdown-result-text'>
            {moneyChoose.title}{' '}
            <span className='item-symbol'>{moneyChoose.symbol}</span>
          </div>
        </div>
      )
    } else {
      return (
        <div className='dropdown-result'>
          <span className='dropdown-result-text'>
            What currency do you have?
          </span>
        </div>
      )
    }
  }, [moneyChoose])

  const onChooseMoney = (money) => () => {
    switch (money) {
      case 'vnd':
        setMoneyChoose({
          value: 'vnd',
          title: 'Vietnamese Dong',
          symbol: 'VND',
          icon: images.vnd,
        })
        break
      case 'usdt':
        setMoneyChoose({
          value: 'usdt',
          title: 'USDT',
          symbol: 'VRC25',
          icon: images.usdt,
        })
        break
      case 'wusd':
        setMoneyChoose({
          value: 'wusd',
          title: 'WUSD',
          symbol: 'VRC25',
          icon: images.wusd,
        })
        break
    }
    setIsOpen(false)
  }

  return (
    <div className='dropdown-wrapper'>
      <div className='dropdown'>
        <div className='dropdown-header' onClick={() => setIsOpen(!isOpen)}>
          {resultDropdown}
          <span
            className={`icon-arrow-down arrow-down ${
              isOpen && 'arrow-down--active'
            }`}></span>
        </div>

        <div
          className={`dropdown-content-container dropdown-content-container--${
            isOpen && 'active'
          }`}>
          <div className='dropdown-content'>
            <div className='title-dropdown-content'>Fiat</div>
            <div
              className={`dropdown-item ${
                moneyChoose === 'vnd' && 'dropdown-item--active'
              }`}
              onClick={onChooseMoney('vnd')}>
              <div className='item-text'>
                <img src={images.vnd} alt='' className='icon-img' />
                Vietnamese Dong
              </div>

              <div className='item-symbol'>VND</div>
            </div>

            <div className='title-dropdown-content'>Stablecoin</div>
            <div
              className={`dropdown-item ${
                moneyChoose === 'usdt' && 'dropdown-item--active'
              }`}
              onClick={onChooseMoney('usdt')}>
              <div className='item-text'>
                <img src={images.usdt} alt='' className='icon-img' />
                USDT
              </div>

              <div className='item-symbol'>VRC25</div>
            </div>

            <div
              className={`dropdown-item ${
                moneyChoose === 'wusd' && 'dropdown-item--active'
              }`}
              onClick={onChooseMoney('wusd')}>
              <div className='item-text'>
                <img src={images.wusd} alt='' className='icon-img' />
                WUSD
              </div>

              <div className='item-symbol'>VRC25</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Dropdown
